import React, { Fragment } from 'react';
import { Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Operation } from '../../../../services/types/Operation';
import { OperActionPlan } from '../../../../services/types/ActionPlan';
import ActionPlanVersion from './ActionPlanVersion';
import EmptyList from './EmptyList';

interface Props {
  operation: Operation;
  items: OperActionPlan[];
  type?: 'current' | 'previous';
  className?: string;
}

const VersionTable: React.FC<Props> = ({ operation, items, type, className }) => {
  const { t } = useTranslation();

  const renderRows = items.map((item) => (
    <Fragment key={item.id}>
      <ActionPlanVersion key={`tv_${item.version}`} item={item} type={type} />
    </Fragment>
  ));

  return (
    <div className={className}>
      <hr />
      <div className="table-wrapper sticky-section w-100">
        <Table className="toolkit_table">
          <thead>
            <tr>
              <th>{t('documentName')}</th>
              <th>{t('createdBy')}</th>
              <th>{t('creationDate')}</th>
              <th>{t('modifiedBy')}</th>
              <th>{t('modifiedDate')}</th>
              <th>{t('language')}</th>
              <th>{t('actions')}</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && type === 'current' ? (
              <EmptyList number={operation.number} />
            ) : (
              renderRows
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default VersionTable;
